import React, { Component } from 'react';
import { FlexView, Separator } from '@cuemath/comps';
import { Popup as Tooltip } from 'semantic-ui-react';

import { Link } from 'react-router-dom';
import Popup from 'reactjs-popup';
import COLORS from 'constants/colors';
import { tabs as leftNavTabs, MORE_OPTIONS, TABS } from 'constants/left-nav';
import { MenuText, MenuWrapper, MenuCol, StyledLink } from 'comps';

import {
  IconCol,
  IconWrapper,
  LeadsContainer,
  Overlay,
  StyledCol,
  WhiteBar,
  Wrapper,
} from './styled';
import { trackEvent } from 'modules/analytics';
import { connect } from 'react-redux';
import { EVENT_TYPE } from 'constants/logger';

const { STUDENTS, TEACHER, CONTACT_US, TEACHER_MAP, MORE } = leftNavTabs;

const customStyle = {
  position: 'absolute',
  padding: '8px 0px',
  borderRadius: 8,
  boxShadow: '0px 2px 16px rgba(0, 0, 0, 0.15)',
  border: `1px solid ${COLORS.GHOST}`,
  background: 'white',
};

class MasterTemplate extends Component {
  constructor(props) {
    super(props);
    this.state = {
      hoveredTab: '',
      demoRatingsUpdated: false,
      originalUrl: '',
      moreOptionsTabSelected: false,
    };
    this.leadPopupRef = React.createRef();
    this.teacherMapRef = React.createRef();
    this.studentsRef = React.createRef();
    this.contactUsRef = React.createRef();
    this.teacherRef = React.createRef();
    this.moreRef = React.createRef();
    this.moreOptionRef = React.createRef();

    this.REF_MAP = {
      [STUDENTS]: this.studentsRef,
      [TEACHER]: this.teacherRef,
      [CONTACT_US]: this.contactUsRef,
      [TEACHER_MAP]: this.teacherMapRef,
      [MORE]: this.moreRef,
    };
  }

  componentDidMount() {
    const url = window.location.pathname;
    const { changeGlobalActiveTab } = this.props;

    const currentItem = TABS.filter(item => {
      let match = null;

      if (item.startsWith) {
        item.startsWith.forEach(sw => {
          if (url.startsWith(sw)) match = true;
        });
      }

      return item.link === url || match;
    });

    const leadsItem = MORE_OPTIONS.filter(
      item => item.link === url || url.startsWith(item.startsWith),
    );

    if (currentItem.length) {
      const [{ id }] = currentItem;

      this.setState({
        originalUrl: url,
      });
      changeGlobalActiveTab(id);
    }

    if (leadsItem.length) {
      this.setState({
        originalUrl: url,
      });
      changeGlobalActiveTab(MORE);
    }
  }

  changeActiveTab = tabId => {
    const { changeGlobalActiveTab, activeTab } = this.props;
    const eventTab = tabId === 'MORE' ? 'MORE_ACTIONS_BB' : tabId;

    if (activeTab === tabId) return;

    trackEvent(EVENT_TYPE.LEFT_PANEL_CLICK, {
      tab: eventTab,
    });
    changeGlobalActiveTab(tabId);
  };

  changeHoveredTab = (tabId, enter) => {
    this.setState({
      hoveredTab: enter ? tabId : null,
    });
  };

  handleMoreOptionsClick = value => {
    this.setState({
      moreOptionsTabSelected: value,
    });
  };

  closePopup = () => {
    if (this.moreOptionRef.current) {
      const { changeGlobalActiveTab } = this.props;
      this.moreOptionRef.current.close();

      changeGlobalActiveTab(MORE);
    }
  };

  renderLeadsManagement() {
    const { hoveredTab } = this.state;
    const url = window.location.pathname;
    const leadsItem = MORE_OPTIONS.find(
      item => item.link === url || url.startsWith(item.startsWith),
    );

    const { id: selectedId } = leadsItem || {};

    return MORE_OPTIONS.map(tab => {
      const { id, link, label } = tab;

      return (
        <MenuWrapper
          key={id}
          onMouseEnter={() => this.changeHoveredTab(id, true)}
          onMouseLeave={() => this.changeHoveredTab(id, false)}
          hovered={hoveredTab === id}
          onClick={this.closePopup}
        >
          <StyledLink to={link}>
            <MenuCol>
              <MenuText selected={selectedId === id}>{label}</MenuText>
            </MenuCol>
          </StyledLink>
        </MenuWrapper>
      );
    });
  }

  renderWhiteBar = activetab => {
    const { leftNavSliderTop } = this.props;
    const iconBounds = this.REF_MAP[activetab]?.current?.getBoundingClientRect();
    if (!iconBounds) return null;

    const { top } = iconBounds || {};

    const prevTop = leftNavSliderTop || top;

    return <WhiteBar top={top} prevTop={prevTop} />;
  };

  render() {
    const { activeTab } = this.props;
    const { hoveredTab, moreOptionsTabSelected } = this.state;

    return (
      <Wrapper justifyContent="center" alignItems="center">
        <StyledCol>
          {activeTab && this.renderWhiteBar(activeTab)}
          {TABS.map((tab, index) => {
            const { id, label, link, icon, selectedIcon } = tab;

            if (id === MORE) {
              return (
                <div key={index}>
                  <Separator height={8} transparent />
                  <Popup
                    key={id}
                    ref={this.moreOptionRef}
                    trigger={
                      <div>
                        <Tooltip
                          trigger={
                            <FlexView
                              onClick={() => this.handleMoreOptionsClick(true)}
                              ref={this.REF_MAP[id]}
                            >
                              <IconCol
                                onMouseEnter={() => this.changeHoveredTab(id, true)}
                                onMouseLeave={() => this.changeHoveredTab(id, false)}
                                alignItems="center"
                              >
                                <LeadsContainer>
                                  <IconWrapper>
                                    {moreOptionsTabSelected || activeTab === id
                                      ? selectedIcon
                                      : icon}
                                  </IconWrapper>
                                </LeadsContainer>
                                {hoveredTab === id && <Overlay width={40} />}
                              </IconCol>
                            </FlexView>
                          }
                          content={label}
                          size="mini"
                          position="right center"
                          inverted
                        />
                      </div>
                    }
                    onClose={() => this.handleMoreOptionsClick(false)}
                    offsetY={-30}
                    offsetX={10}
                    position="right top"
                    on="click"
                    closeOnDocumentClick
                    contentStyle={customStyle}
                    arrow={false}
                  >
                    <FlexView>{this.renderLeadsManagement()}</FlexView>
                  </Popup>
                </div>
              );
            }

            return (
              <div key={index}>
                <Separator height={8} transparent />
                <Tooltip
                  trigger={
                    <Link
                      key={id}
                      to={link}
                      onClick={() => this.changeActiveTab(id)}
                      ref={this.REF_MAP[id]}
                    >
                      <IconCol
                        onMouseEnter={() => this.changeHoveredTab(id, true)}
                        onMouseLeave={() => this.changeHoveredTab(id, false)}
                        alignItems="center"
                        marginTop={index === 0}
                      >
                        {hoveredTab === id && <Overlay width={40} />}
                        {activeTab === id ? selectedIcon : icon}
                      </IconCol>
                    </Link>
                  }
                  content={label}
                  size="mini"
                  position="right center"
                  inverted
                />
              </div>
            );
          })}
        </StyledCol>
      </Wrapper>
    );
  }
}

export default connect(({ auth: { userId } = {} }) => ({
  userId,
}))(MasterTemplate);
